module.exports = __webpack_public_path__ + "static/media/change-degrees.63113576.png";